// Framework UIkit
window.UIkit = require('uikit');
let Icons = require('uikit/dist/js/uikit-icons');
UIkit.use(Icons);
